import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { LiveBanner } from "./components/LiveBanner";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Media } from "./pages/Media";
import { Outreach } from "./pages/Outreach";
import { Donate } from "./pages/Donate";
import { Join } from "./pages/Join";
import { Events } from "./pages/Events";
import { Contact } from "./pages/Contact";
import { Privacy } from "./pages/Privacy";
import { BibleApp } from "./pages/BibleApp";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Navbar />
        <LiveBanner />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/media" element={<Media />} />
            <Route path="/outreach" element={<Outreach />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/join" element={<Join />} />
            <Route path="/events" element={<Events />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/bible-app" element={<BibleApp />} />
          </Routes>
        </main>
        <Footer />
        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: '#0A0A0A',
              border: '1px solid #333333',
              color: '#F5F5F5',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
